// action creators
import { historyH } from '../store';
import Api from '../api';
import { getDataset } from '../selectors';
import { IdGen } from '../utils';
import { TAB, ROUTE, DATASETS, FACETS, CARDS } from './types';
import { simple, withPayload, withLogic } from './createActionCreator';

/* consider refactoring const var = function to actual
functions to take advance function hoisting */

let toExport = {};
const idGen = IdGen();

/**  -------------   -------------   - PANELS AND APP FUNCTIONALITY */

const goToRoute = route => withLogic(
  ROUTE.PUSH, async (dispatch) => {
    historyH.push(route);
  }
);

// the route that the user is viewing now
const saveCurrentLocation = withPayload(ROUTE.SAVE_LOCATION);

toExport = { ...toExport, goToRoute, saveCurrentLocation };

/**  -------------   -------------   -------------  TABS FUNCTIONALITY */

const openTabSuccess = withPayload(TAB.OPEN_SUCCEEDED);
function openTab(datasetId, sessionId) {
  return async (dispatch, getState) => {
    dispatch(simple(TAB.OPEN)()); // log action to actions history
    /* for now use dataset to get mock data, once endpoint is availiable
    should be able to return data with just the session id */
    /* also this could be refactored to getMainView data or sth like this */
    /* should use dataset to find it not datasetId - this is due to api change
    dataset being diff than datasetId */
    const dataset = await getDataset(getState, datasetId);
    // TODO: if dataset === null dispatch error func that alerts user && return
    const title = dataset.info;
    const tabId = idGen.next().value;
    await dispatch(openTabSuccess({ dataset, tabId, sessionId, title }));
    dispatch(goToRoute(`/dataset/${tabId}`));
  };
}

const closeTabSuccess = withPayload(TAB.CLOSE_SUCCEEDED);
const closeTab = tabId => withLogic(
  TAB.CLOSE, async (dispatch) => {
    // todo: probably I also need to let the server know I closed that tab
    dispatch(closeTabSuccess({ tabId }));
  }
);

const updateViewOption = withPayload(TAB.UPDATE_VIEW_OPTION);
const updateMapOption = withPayload(TAB.UPDATE_MAP_OPTION);

toExport = { ...toExport, openTab, closeTab, updateViewOption, updateMapOption };

/**  -------------   -------------   -------------  REQUESTING DATA */

const requestDatasetsFailed = simple(DATASETS.REQUEST_FAILED); // unimplemented
const receivedDatasets = withPayload(DATASETS.REQUEST_SUCCEEDED);
const requestDatasets = () => withLogic(
  DATASETS.REQUEST, async (dispatch) => {
    // const { data, err, errMsg } = await Api.receiveDatasets();
    const { data } = await Api.receiveDatasets();

    if (!data) {
      dispatch(requestDatasetsFailed('error'));
    }

    dispatch(receivedDatasets(data));
  }
);


toExport = { ...toExport, requestDatasets };

/**  -------------   -------------   --- SESSION ID */

const requestSessionId = (datasetId, dataset) => withLogic(
  'SESSION-ID.REQUEST', async (dispatch) => {

    // const dataset = 'fishBase700';
    /* const { data, error } = await Api.getSessionId(dataset); */
    const newSessionId = `session${idGen.next().value}`;

    /* if (!data) {
      // dispatch(requestSessionIdFailed('error'));
      console.log('requestSessionId - error');
    } */

    // console.log(JSON.stringify(data, null, 2));

    /* refactor to pass dataset ? (why is it different than datasetId) */
    /* dispatch(openTab(datasetId, data.stateID)); */
    dispatch(openTab(datasetId, newSessionId));
    // dispatch(receivedDatasets(data));
  }
);


toExport = { ...toExport, requestSessionId };

/**  -------------   -------------   --- LEFT PANE FACETS FUNCTIONALITY */

const requestOfAllFacetTypesFailed = simple(FACETS.REQUEST_TYPES_ALL_FAILED); // unimplemented
const receivedAllFacetTypes = withPayload(FACETS.REQUEST_TYPES_ALL_SUCCEEDED);
const requestAllFacetTypes = () => withLogic(
  FACETS.REQUEST_TYPES_ALL, async (dispatch) => {
    const { data, err, errMsg } = await Api.receiveAllFacetTypes();

    if (err) {
      dispatch(requestOfAllFacetTypesFailed(errMsg));
    }

    dispatch(receivedAllFacetTypes(data));
  }
);

const requestOfAllFacetSubTypesFailed = simple(FACETS.REQUEST_SUBTYPES_ALL_FAILED); // unimplemented
const receivedAllFacetSubTypes = withPayload(FACETS.REQUEST_SUBTYPES_ALL_SUCCEEDED);
const requestAllFacetSubTypes = () => withLogic(
  FACETS.REQUEST_SUBTYPES_ALL, async (dispatch) => {
    const { data, err, errMsg } = await Api.receiveAllFacetSubTypes();

    if (err) {
      dispatch(requestOfAllFacetSubTypesFailed(errMsg));
    }

    dispatch(receivedAllFacetSubTypes(data));
  }
);

const requestAllFacets = () => async (dispatch) => {
  dispatch(requestAllFacetTypes());
  dispatch(requestAllFacetSubTypes());
};

toExport = { ...toExport, requestAllFacetTypes, requestAllFacetSubTypes, requestAllFacets };

/**  -------------   -------------   --- PAGINATION BODY FUNCTIONALITY */

/** request failed due to uknown cause eg connection problem */
const cardsReqFailed = simple(CARDS.REQUEST_FAILED);
/** request succeeded and cards received */
const cardsReceived = withPayload(CARDS.RECEIVED);
/** request succeed but failed business wise eg no cards returned */
const cardsFailed = simple(CARDS.FAILED);

const requestMainViewCards = () => withLogic(
  CARDS.REQUEST, async (dispatch) => {
    const { data, err, errMsg } = await Api.getMainViewCards();

    if (err) {
      dispatch(cardsFailed(errMsg));
    }

    dispatch(cardsReceived(data));

  }
);

toExport = { ...toExport, requestMainViewCards };


//


const exports = toExport;
export default exports;
